// @flow
import React, { useState, Fragment } from "react";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";
import classNames from "classnames";
import ImageEditor from "../image-editor";

const type = "file";
const excludedProps = ["id", "children", "className", "errorMessage", "isError", "labelText", "readyMessage", "onChange", "value"];

const filterProps = _props => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {}),
    type,
    id: _props.id || uuid(),
    accept: "image/*",
    capture: ["user", "environment"].indexOf(_props.capture) ? _props.capture : "environment"
});


type PropsType = {
    image?: string,
    id?: string,
    disabled?: boolean,
    errorMessage?: string,
    isError?: boolean,
    labelText?: string,
    onChange: any => void,
    readOnly?: boolean,
    required?: boolean,
    dimensions: Object,
    style?: object
};

const MyComponent = ({
                         value,
                         id,
                         disabled = false,
                         errorMessage = "Error",
                         isError = false,
                         dimensions,
                         labelText,
                         onChange,
                         readOnly = false,
                         required = false,
                         style = {}
                     }: PropsType) => {
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    return (
        <Fragment>
            <article className={ classNames(
                "image-control", {
                    "is-required": required,
                    "is-error": isError,
                    "is-disabled": disabled,
                    "is-read-only": readOnly
                }) }>
            <span className="image-control--label">
                    <span className={ "image-control--label-text" }>
                        { labelText || "Image" }
                        <span className="image-control--error">{ errorMessage || "Error!" }</span>
                    </span>
            </span>
                <input
                    onClick={ () => {
                        setIsEditorOpen(true);
                    } }
                    className={ "image-control--image-button" }
                    type="image"
                    alt="celebration hero image"
                    src={ value }/>

            </article>
            <div className={ classNames("image-control--modal", { "is-open": isEditorOpen }) }>
                <ImageEditor onClose={ () => {
                    setIsEditorOpen(false);
                } }/>
            </div>
        </Fragment>
    );
};


export const ImageControl = withValidation(MyComponent);